<!-- @format -->

<template>
	<span v-if="title" class="pcp-header-name" @click="handleClick">{{ title }}</span>
</template>

<script setup lang="ts">
	import { useGlobalStoreWithOut, getFrontEndConfigItemByCodeAndItemCode, getEnvUrlByUrl } from '@power/runtime-vue3';
	const globalStore = useGlobalStoreWithOut();
	//const isShowHeaderName = inject('isShowHeaderName');
	const title = computed(() => {
		const title = getFrontEndConfigItemByCodeAndItemCode(globalStore.frontEndConfig, 'login', 'title')?.itemValue || '';
		return title;
		//return isShowHeaderName ? title || globalStore.curSystem?.name : globalStore.curSystem?.name || title;
	});
	const handleClick = () => {
		const url = getEnvUrlByUrl('/');
		if (window.parent === window.self) {
			window.location.href = url;
		} else {
			window.parent.location.href = url;
		}
	};
</script>

<style lang="scss" scoped>
	.pcp-header-name {
		cursor: pointer;
		font-size: 24px;
		color: #fff;
		letter-spacing: 0;
		line-height: 30px;
	}
</style>
